var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
/**
 * Apply a css style to multiple styled components
 * @param styledComponents styled components to add the css in styles to
 * @param styles the css style declarations to pass to the styled tagged template literla
 * @returns styled component array
 */
export var addStyleToComponents = function (styledComponents, styles) {
    var toExtendedComponents = function (component) { return styled(component)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), styles); };
    return styledComponents.map(toExtendedComponents);
};
var templateObject_1;
//# sourceMappingURL=styleUtils.js.map